import get from "lodash/get";
import {useState} from "react";
import {RegisterOptions, useFormContext} from "react-hook-form";

import {InputField, InputFieldProps} from "@/components/form/fields/InputField/InputField.tsx";
import {Input} from "@/components/input/Input.tsx";

import {getRequiredError} from "../constants.ts";

interface PercentageFieldProps extends InputFieldProps {}

/*
percentage field migrated from original check form
try to utilize Yup validators at first before using this one
check form has limited UI validation
 */
export const PercentageField = ({name, required, ...rest}: PercentageFieldProps) => {
  const {
    setValue,
    formState: {defaultValues},
  } = useFormContext();
  let defaultValue = get(defaultValues, name);
  if (parseFloat(defaultValue) <= 1) {
    defaultValue = (parseFloat(defaultValue) * 100).toFixed(4);
  }
  const [userValue, setUserValue] = useState<string>(defaultValue);
  const options: RegisterOptions = {};
  if (required) {
    options.required = getRequiredError(name);
  }
  const calculateFormValue = (userValue: string) => {
    if (userValue === "") {
      return "";
    }

    // @ts-expect-error copied from legacy field to behave in the same way
    const formValue = userValue / 100.0;
    if (isNaN(formValue) || formValue === null) {
      return userValue;
    } else {
      // DB format for 99.1234% is 0.991234, so we need 6 decimal places for four 9's SLA
      return formValue.toFixed(6);
    }
  };

  return (
    <InputField
      name={name}
      required={required}
      {...rest}
      input={
        <Input
          type="text"
          value={userValue}
          onChange={(e) => {
            setUserValue(e.target.value);
            setValue(name, calculateFormValue(e.target.value), {shouldDirty: true, shouldValidate: true});
          }}
        />
      }
    />
  );
};
